// extracted by mini-css-extract-plugin
module.exports = {"questionAnswer":"QuestionAnswerWebform_questionAnswer__3oG9z"};